// Per-ticket scan-log columns: scan time · attendee · email · ticket type, plus
// a Seat column appended only for seated events (see PunchupScansTable). Keys
// feed `useResizableColumns` — each resolves to a `max-content` track at rest and
// a `<userWidth>px` track once the user drags the resize handle. See PunchupTable
// CLAUDE.md → "Column width strategy".
export const SCANS_COLUMN_KEYS = ['scannedAt', 'fullName', 'email', 'ticketType'] as const;
export const SCANS_SEAT_KEY = 'seat';
